export default __webpack_public_path__ + "static/media/2022-1.d3e8adfb.jpg";